var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaySolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.596 8.69701L5.233 12.389C4.693 12.702 4 12.323 4 11.692V4.30801C4 3.67801 4.692 3.29801 5.233 3.61201L11.596 7.30401C11.7188 7.37414 11.8209 7.4755 11.892 7.59782C11.963 7.72014 12.0004 7.85907 12.0004 8.00051C12.0004 8.14196 11.963 8.28088 11.892 8.4032C11.8209 8.52553 11.7188 8.62689 11.596 8.69701V8.69701Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaySolid);
export default __webpack_public_path__ + "static/media/Play-Solid.da0561a805b4396f2321c8bae1ba56fe.svg";
export { ForwardRef as ReactComponent };